module.exports = __webpack_public_path__ + "static/custom-marker-shapes-6cbf909f95070facbcfebeb8ed744b56.png";